<template>
  <div class="collection">
    <div class="collection-header">
      <p class="collection-title">{{ Translator('soprasolar.project.step4_shade.collection.title', {number: index + 1}) }}</p>
      <button type="button" @click="onDelete" class="collection-button" v-if="shades.length > 0">
        <i class="ic ic-trash"></i>
        {{ Translator('soprasolar.project.step4_shade.collection.delete') }}
      </button>
    </div>

    <div class="form-group">
      <div class="form-label-container">
        <label class="control-label required">
          {{ Translator('soprasolar.project.step4_shade.form.type.label') }}
        </label>
      </div>
      <div class="radios">
        <div class="radio">
          <input class="radio-input" required type="radio" :id="'single_centralpost-' + index" :name="'type-' + index" v-model="form.type" value="single_centralpost">
          <label class="radio-label" :for="'single_centralpost-' + index">
            <p class="radio-label-text">{{ Translator('soprasolar.project.step4_shade.form.type.single_centralpost') }}</p>
            <div class="radio-label-media">
              <img src="/assets/soprasolar/images/project/type_single_centralpost.png" :alt="Translator('soprasolar.project.step4_shade.form.type.single_centralpost')">
            </div>
          </label>
        </div>
        <div class="radio">
          <input class="radio-input" required type="radio" :id="'single_sandpit-' + index" :name="'type-' + index" v-model="form.type" value="single_sandpit">
          <label class="radio-label" :for="'single_sandpit-' + index">
            <p class="radio-label-text">{{ Translator('soprasolar.project.step4_shade.form.type.single_sandpit') }}</p>
            <div class="radio-label-media">
              <img src="/assets/soprasolar/images/project/type_single_sandpit.png" :alt="Translator('soprasolar.project.step4_shade.form.type.single_sandpit')">
            </div>
          </label>
        </div>
        <div class="radio">
          <input class="radio-input" required type="radio" :id="'single_ridge-' + index" :name="'type-' + index" v-model="form.type" value="single_ridge">
          <label class="radio-label" :for="'single_ridge-' + index">
            <p class="radio-label-text">{{ Translator('soprasolar.project.step4_shade.form.type.single_ridge') }}</p>
            <div class="radio-label-media">
              <img src="/assets/soprasolar/images/project/type_single_ridge.png" :alt="Translator('soprasolar.project.step4_shade.form.type.single_ridge')">
            </div>
          </label>
        </div>
        <div class="radio">
          <input class="radio-input" required type="radio" :id="'single_with_valley-' + index" :name="'type-' + index" v-model="form.type" value="single_with_valley">
          <label class="radio-label" :for="'single_with_valley-' + index">
            <p class="radio-label-text">{{ Translator('soprasolar.project.step4_shade.form.type.single_with_valley') }}</p>
            <div class="radio-label-media">
              <img src="/assets/soprasolar/images/project/type_single_with_valley.png" :alt="Translator('soprasolar.project.step4_shade.form.type.single_with_valley')">
            </div>
          </label>
        </div>

        <div class="radio">
          <input class="radio-input" required type="radio" :id="'other' + index" :name="'type-' + index" v-model="form.type" value="other">
          <label class="radio-label" :for="'other' + index">
            <p class="radio-label-text">{{ Translator('soprasolar.project.step4_shade.form.type.other') }}</p>
          </label>
        </div>
      </div>
    </div>

    <div class="form-group">
      <div class="form-label-container">
        <label for="destination" class="control-label required">
          {{ Translator('soprasolar.project.step4_shade.form.destination.label') }}
        </label>
      </div>
      <select id="destination" required class="form-control" v-model="form.destination">
        <option value=""></option>
        <option value="car_park">{{ Translator('soprasolar.project.step4_shade.form.destination.car_park') }}</option>
        <option value="multistorey">{{ Translator('soprasolar.project.step4_shade.form.destination.multistorey') }}</option>
        <option value="covered">{{ Translator('soprasolar.project.step4_shade.form.destination.covered') }}</option>
        <option value="bowling_alley">{{ Translator('soprasolar.project.step4_shade.form.destination.bowling_alley') }}</option>
        <option value="pergola">{{ Translator('soprasolar.project.step4_shade.form.destination.pergola') }}</option>
        <option value="sports_cover">{{ Translator('soprasolar.project.step4_shade.form.destination.sports_cover') }}</option>
        <option value="other">{{ Translator('soprasolar.project.step4_shade.form.destination.other') }}</option>
      </select>
    </div>

    <div class="form-group">
      <div class="form-label-container">
        <label for="breakdown" class="control-label required">
          {{ Translator('soprasolar.project.step4_shade.form.type_of_breakdown.label') }}
        </label>
      </div>
      <select id="breakdown" required class="form-control" v-model="form.breakdown">
        <option value=""></option>
        <option value="steel">{{ Translator('soprasolar.project.step4_shade.form.type_of_breakdown.steel') }}</option>
        <option value="wood_glued">{{ Translator('soprasolar.project.step4_shade.form.type_of_breakdown.wood_glued') }}</option>
        <option value="wood_solid">{{ Translator('soprasolar.project.step4_shade.form.type_of_breakdown.wood_solid') }}</option>
        <option value="dontknow">{{ Translator('soprasolar.project.step4_shade.form.type_of_breakdown.dontknow') }}</option>
      </select>
    </div>

    <div class="form-group">
      <div class="form-label-container">
        <label :for="'roof_pitch-' + index" class="control-label required">
          {{ Translator('soprasolar.project.step4_shade.form.roof_pitch') }}
        </label>
        <help :image="'/assets/soprasolar/images/project/help-shade-cut-park-v3.png'" />
      </div>
      <input type="text" :id="'roof_pitch-' + index" class="form-control" v-model="form.roof_pitch" required>
    </div>

    <div class="form-group">
      <div class="form-label-container">
        <label :for="'height_bottom-' + index" class="control-label required">
          {{ Translator('soprasolar.project.step4_shade.form.height_bottom') }}
        </label>
        <help :image="'/assets/soprasolar/images/project/help-shade-cut-park-v3.png'" />
      </div>
      <input type="text" :id="'height_bottom-' + index" class="form-control" v-model="form.height_bottom" required>
    </div>

    <div class="form-group">
      <div class="form-label-container">
        <label :for="'height_brace-' + index" class="control-label">
          {{ Translator('soprasolar.project.step4_shade.form.height_brace') }}
        </label>
        <help :image="'/assets/soprasolar/images/project/help-shade-cut-park-v3.png'" />
      </div>
      <input type="text" :id="'height_brace-' + index" class="form-control" v-model="form.height_brace">
    </div>

    <div class="form-group">
      <div class="form-label-container">
        <label :for="'congestion_rate-' + index" class="control-label">
          {{ Translator('soprasolar.project.step4_shade.form.congestion_rate') }}
        </label>
        <help :image="'/assets/soprasolar/images/project/help-congestion-rate.png'" />
      </div>
      <input type="text" :id="'congestion_rate-' + index" class="form-control" v-model="form.congestion_rate">
      <p class="help-text">{{ Translator('soprasolar.project.step4_shade.form.congestion_rate_help') }}</p>
    </div>

    <template v-if="datas.step3.sizes === 'approximate'">
      <div class="form-group">
        <div class="form-label-container">
          <label :for="'approximate_length-' + index" class="control-label required">
            {{ Translator('soprasolar.project.step4_shade.form.approximate_length') }}
          </label>
          <help :image="'/assets/soprasolar/images/project/help-shade-park.png'" />
        </div>
        <input type="text" :id="'approximate_length-' + index" class="form-control" v-model="form.approximate_length" required>
      </div>

      <div class="form-group">
        <div class="form-label-container">
          <label :for="'approximate_crawling-' + index" class="control-label required">
            {{ Translator('soprasolar.project.step4_shade.form.approximate_crawling') }}
          </label>
          <help :image="'/assets/soprasolar/images/project/help-shade-park.png'" />
        </div>
        <input type="text" :id="'approximate_crawling-' + index" class="form-control" v-model="form.approximate_crawling" required>
      </div>
    </template>

    <template v-if="datas.step3.sizes === 'modules'">
      <div class="form-group">
        <div class="form-label-container">
          <label :for="'number_modules_length-' + index" class="control-label required">
            {{ Translator('soprasolar.project.step4_shade.form.number_modules_length') }}
          </label>
          <help :image="'/assets/soprasolar/images/project/help-shade-pak-modules.png'" />
        </div>
        <input type="text" :id="'number_modules_length-' + index" class="form-control" v-model="form.number_modules_length" required>
      </div>

      <div class="form-group">
        <div class="form-label-container">
          <label :for="'rampant_modules_length-' + index" class="control-label required">
            {{ Translator('soprasolar.project.step4_shade.form.rampant_modules_length') }}
          </label>
          <help :image="'/assets/soprasolar/images/project/help-shade-pak-modules.png'" />
        </div>
        <input type="text" :id="'rampant_modules_length-' + index" class="form-control" v-model="form.rampant_modules_length" required>
      </div>
    </template>

    <div class="checkbox form-group">
      <input type="checkbox" id="rail_overhang" v-model="form.rail_overhang" @change="onChange()">
      <label for="rail_overhang" class="control-label">
        {{ Translator('soprasolar.project.step4_shade.form.rail_overhang_label') }}
      </label>
    </div>

    <template v-if="form.rail_overhang">
      <div class="form-group">
        <div class="form-label-container">
          <label :for="'rail_overhang_detail-' + index" class="control-label required">
            {{ Translator('soprasolar.project.step4_shade.form.rail_overhang_detail') }}
          </label>
        </div>
        <input type="text" :id="'rail_overhang_detail-' + index" class="form-control" v-model="form.rail_overhang_detail" required>
      </div>
    </template>
    <div class="collection-actions">
      <button type="button" @click="onDupplicate" class="collection-button">
        <i class="ic ic-dupplicate"></i>
        {{ Translator('soprasolar.project.step4_shade.collection.dupplicate') }}
      </button>
    </div>
  </div>

</template>
<style scoped lang="scss">
  @import "~@/soprasolar-project/assets/styles/import";
  .collection {
    margin-bottom: rem(30);
    .collection-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .collection-title {
      font-weight: bold;
      font-size: rem(18);
      margin-bottom: .5em;
      color: $color-second;
    }
    .collection-actions {
      display: flex;
      justify-content: flex-end;
    }
    .collection-button {
      @include resetBtn;
      padding: rem(10) rem(15);
      display: flex;
      align-items: center;
      gap: rem(10);
      color: $color-main;
      .ic {
        vertical-align: middle;
        font-size: rem(24);
      }
    }
  }
</style>
<script>
import AppControlService from '@/soprasolar-project/services/AppControl';
import Help from '@/soprasolar-project/components/Help';

export default {
  props: ['form', 'shades', 'index'],
  name: 'form-shade',
  components: {
    Help
  },
  data () {
    return {
      datas: AppControlService.datas,
    }
  },

  created() {
    AppControlService.on('datas', this._onUpdateDatas);
  },

  beforeDestroy() {
    AppControlService.off('datas', this._onUpdateDatas);
  },

  mounted() {
  },
  methods: {
    onDupplicate() {
      const clone = {...this.form};
      this.shades.push(clone);
    },

    onChange() {
      // this.form._formGrabDom();
    },

    onDelete() {
      this.shades.splice(this.index, 1);
    },

    Translator(key, datas = null) {
      return window.Translator.trans(key, datas);
    },

    _onUpdateDatas(datas) {
      this.datas = datas;
    }
  }
};
</script>